/**
 * 模块: DataCheck工具函数
 * 职责: 数据统计和计算逻辑
 * 限制: 文件<280行, 函数<30行
 */

import { DataRow, Stats } from './types';

/**
 * 计算统计数据
 */
export function calculateStats(data: DataRow[]): Stats {
  if (!data.length) {
    return { 
      totalRecords: 0,
      periodCount: 0,
      uniqueKeywords: 0,
      uniqueASINs: 0
    };
  }
  
  const periods = new Set(data.map(d => d.period_week));
  const keywords = new Set(data.map(d => d.keyword));
  const asins = new Set<string>();
  
  data.forEach(d => {
    if (d.top1_asin) asins.add(d.top1_asin);
    if (d.top2_asin) asins.add(d.top2_asin);
    if (d.top3_asin) asins.add(d.top3_asin);
  });
  
  return {
    totalRecords: data.length,
    periodCount: periods.size,
    uniqueKeywords: keywords.size,
    uniqueASINs: asins.size
  };
}

